import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faCommentAlt,
  faComments,
  faHeartPulse,
  faMoon,
  faSun,
  faTimes,
  faDatabase,
} from "@fortawesome/free-solid-svg-icons";
import Switch from "react-switch";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBS-EqIrZAdnjXGlMs3dydugOnmAasQRJs",
  authDomain: "studizy-145f8.firebaseapp.com",
  projectId: "studizy-145f8",
  storageBucket: "studizy-145f8.firebasestorage.app",
  messagingSenderId: "86368888321",
  appId: "1:86368888321:web:99c2df081e6970ed6f8200",
};
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

async function registerForPush() {
  // debug alerts for iOS
  alert("Debug: Starting registerForPush");
  alert("Debug: serviceWorker supported = " + !!navigator.serviceWorker);
  if (!navigator.serviceWorker) {
    alert("Service workers not supported");
    return;
  }
  try {
    const swUrl = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`;
    alert("Debug: Registering service worker at " + swUrl);
    const registration = await navigator.serviceWorker.register(swUrl);
    alert("Debug: Service worker registered");
    const notifSupported = typeof Notification !== "undefined";
    alert("Debug: Notification supported = " + notifSupported);
    if (!notifSupported) {
      alert("Notifications API not supported in this browser");
      return;
    }
    const permission = await Notification.requestPermission();
    alert("Debug: Notification permission = " + permission);
    if (permission !== "granted") {
      alert("Push permission denied");
      return;
    }
    alert("Debug: Requesting FCM token");
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });
    alert("Debug: Received token = " + token);
    console.log("Push token:", token);
    // copy token to clipboard
    if (token && navigator.clipboard) {
      navigator.clipboard
        .writeText(token)
        .then(() => alert("Push token copied to clipboard"))
        .catch((e) => alert("Copy failed: " + e));
    }
  } catch (err) {
    alert("FCM registration failed: " + err);
    console.error("FCM registration failed:", err);
  }
}

const SideBar = ({ isOpen, closeSidebar }) => {
  const location = useLocation();
  const { darkMode, toggleDarkMode } = useTheme();

  const isActive = (path) => location.pathname === path;

  const MenuItem = ({ to, icon, children }) => (
    <li>
      <Link
        to={to}
        className={`menu-item neumorphic ${isActive(to) ? "is-active" : ""}`}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0.8rem 1.2rem",
          margin: "0.5rem 0",
          color: isActive(to) ? "var(--accent-primary)" : "var(--text-primary)",
          textDecoration: "none",
          borderRadius: "10px",
          transition: "all 0.3s ease",
        }}
      >
        <span className="icon is-small mr-2">
          <FontAwesomeIcon icon={icon} />
        </span>
        <span>{children}</span>
      </Link>
    </li>
  );

  return (
    <aside
      className={`sidebar-container column is-2 p-5 neumorphic has-background-light ${
        isOpen ? "is-active" : ""
      }`}
      style={{
        margin: "0 1rem",
        height: "calc(100vh - 100px)",
        transition: "all 0.3s ease",
        zIndex: 40,
        fontFamily: "Poppins, sans-serif",
      }}
    >
      <div className="is-hidden-desktop">
        <div
          className="is-flex is-justify-content-space-between p-3 is-align-items-center mb-4 has-background-light"
          style={{
            borderRadius: "15px",
          }}
        >
          <div className="field mt-3">
            <Switch
              checked={darkMode}
              onChange={toggleDarkMode}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={20}
              uncheckedIcon={false}
              checkedIcon={false}
              height={32}
              width={48}
            />
            <label
              htmlFor="darkModeSwitch"
              style={{
                position: "absolute",
                marginTop: 6,
                marginLeft: 10,
              }}
            >
              <FontAwesomeIcon
                icon={darkMode ? faMoon : faSun}
                color={"gold"}
              />
            </label>
          </div>
          <button
            className="button is-neumorphic is-small"
            onClick={closeSidebar}
            aria-label="close menu"
          >
            <span className="icon">
              <FontAwesomeIcon icon={faTimes} />
            </span>
          </button>
        </div>
        <hr
          className="my-4"
          style={{ background: "var(--border-color)", height: "1px" }}
        />
      </div>

      <nav
        className="menu p-5 has-background-light"
        style={{
          borderRadius: "15px",
        }}
      >
        <div className="menu-section mb-5 ">
          <p
            className="menu-label mb-3"
            style={{ color: "var(--text-secondary)", letterSpacing: "1px" }}
          >
            Generald
          </p>
          <ul className="menu-list">
            <MenuItem to="/dashboard" icon={faChartLine}>
              Dashboard
            </MenuItem>
          </ul>
        </div>

        <div className="menu-section mb-5">
          <p
            className="menu-label mb-3"
            style={{ color: "var(--text-secondary)", letterSpacing: "1px" }}
          >
            Support
          </p>
          <ul className="menu-list">
            <MenuItem to="/chats" icon={faComments}>
              Chats
            </MenuItem>
          </ul>
        </div>
        <div className="menu-section">
          <p
            className="menu-label mb-3"
            style={{ color: "var(--text-secondary)", letterSpacing: "1px" }}
          >
            Infrastructure
          </p>
          <ul className="menu-list ">
            <MenuItem to="/dataset-monitoring" icon={faDatabase}>
              Dataset Monitoring
            </MenuItem>
          </ul>
        </div>
      </nav>
      {/* 
      <button
        className="button is-neumorphic"
        onClick={registerForPush}
        style={{ marginTop: "1rem", width: "100%" }}
      >
        Register for Push
      </button> */}
    </aside>
  );
};

export default SideBar;
